import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getEstimatedAnnualRevenue = {
  name: "getEstimatedAnnualRevenue" as const,
  input: z.object({}),
  output: z.object({
    annualRevenue: z.number().nullable(),
    dataAvailable: z.boolean(),
    reason: createEnum(["no_data", "invalid_data"]).optional(),
  }),
};
